import React from 'react';

import { SomethingWentWrong } from '../ErrorPages/SomethingWentWrong';

export default class ErrorBoundary extends React.Component {
  state = {
    hasError: false,
    error: { message: '', stack: '' },
    info: { componentStack: '' }
  };

  static getDerivedStateFromError = () => ({ hasError: true });

  componentDidCatch = (error, info) => {
    this.setState({ error, info });
  };

  render() {
    const { hasError, error, info } = this.state;
    if (hasError) {
      console.error({ hasError, error, info });
    }
    const { children } = this.props;

    return hasError
      ? (
        <>
          {/* <h1>sorry, something went wrong</h1>
          <button type="button" onClick={ () => { window.location.replace(this.props.currentPortal); }
          }>Reload</button> */}
          <SomethingWentWrong
            location={ this.props.currentPortal }
          />
        </>
      )
      : children;
  }
}
